import { Typography } from '@material-ui/core';
import { Translation, useNavigate } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import { type Dispatch, select } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Logout,
  TXTWCL_AlternativelyX_if_your_details_ELL,
  TXTWCL_Online_Validation_Unsuccessful
} from './ValidationUnsuccessful.messages.json';

interface Props {
  onClose(): void;
}

const ValidationUnsuccessful: React.FC<Props> = ({ onClose }) => {
  const exitWizard = useWizardExit();
  const { auth } = useDispatch<Dispatch>();
  const navigate = useNavigate();
  const { redirectTo } = useSelector(select.localSettings.get);

  const handleClose = () => {
    auth.logout();
    redirectTo ? navigate(redirectTo) : exitWizard();
    onClose();
  };

  return (
    <Prompt
      onClose={handleClose}
      noCloseButton
      variant="default"
      title={{ translation: TXTWCL_Online_Validation_Unsuccessful }}
      onPrimaryButtonClick={handleClose}
      primaryButton={{ translation: TXTCLI_Logout }}
    >
      <Typography>
        <Translation {...TXTWCL_AlternativelyX_if_your_details_ELL} />
      </Typography>
    </Prompt>
  );
};

export default ValidationUnsuccessful;
